import { AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { AppThunk } from 'store';

import { IAddEventCalendarPayload, ICalendarEvent } from '../../entities';
import { CalendarApi } from '../api/calendar.api';
import {
  fetchEvents,
  fetchEventsFailed,
  fetchEventsSucceeded,
} from '../slices/calendar.slice';

export const addEventThunk = <T = any>(
  calendarId: string,
  params: IAddEventCalendarPayload,
): AppThunk<Promise<{ [key: string]: ICalendarEvent<T> }>> => async (
  dispatch: Dispatch<any>,
) => {
  let response: AxiosResponse<ICalendarEvent<T>> = null;
  dispatch(fetchEvents({ key: 'add' }));

  try {
    response = await CalendarApi.addEvent(calendarId, params);
    const event = { [response.data.id]: response.data };
    dispatch(
      fetchEventsSucceeded({
        events: event,
        key: 'add',
        id: response.data.id,
      }),
    );

    return event;
  } catch (err) {
    const { name, response: responseError, stack, isAxiosError } = err;

    const error = {
      isAxiosError,
      message: responseError?.data?.message,
      name,
      code: responseError?.data?.statusCode,
      stack,
      config: null,
      toJSON: null,
    };

    dispatch(
      fetchEventsFailed({
        key: 'add',
        error,
      }),
    );

    throw error;
  }
};
